import { useCallback } from "react";
import { General } from "capitalrx-components-2.0";

export function useFailureHandler(): (err) => void {
  const showAlert = General.useAlert();

  return useCallback(
    (err): void => {
      showAlert({
        message: typeof err === "string" ? err : err.response?.data?.message || err.message,
        type: "error",
        style: "toast",
      });
    },
    [showAlert],
  );
}
